// import { createTheme } from "@mui/material/styles"

// const defaultTheme = createTheme({
//     typography: {
//         fontFamily: " ",
//     },
//     palette: {
//         primary: {
//             main: "#1d5a96",
//             dark: "#f6cc63",
//         },
//         secondary: {
//             main: "#fcfcfc",
//             dark: "#020202",
//         },
//     },
//     breakpoints: {
//         values: {
//             xs: 0,
//             sm: 450,
//             md: 600,
//             lg: 900,
//             xl: 1200
//         }
//     }
// });

// const theme = {
//     ...defaultTheme,
//     // components: {
//     //     MuiButton: {
//     //         styleOverrides: {
//     //             root: {
//     //                 backgroundColor: defaultTheme.palette.primary.main,
//     //                 color: 'white',
//     //                 textTransform: 'none',
//     //                 fontSize: '20px',
//     //                 padding: '0.5rem 3rem',
//     //                 borderRadius: '10px',
//     //                 '&:hover': {
//     //                     color: defaultTheme.palette.primary.main
//     //                 }
//     //             },
//     //         },
//     //     },
//     // },
// };

// export default theme

import { createTheme } from "@mui/material/styles";

const defaultTheme = createTheme({
    typography: {
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        // Optional: typed scale names (MUI's h1..body2)
        h1: { fontSize: "40px", fontWeight: 800, lineHeight: "48px", letterSpacing: "-0.025em" },
        h2: { fontSize: "28px", fontWeight: 700, lineHeight: "36px", letterSpacing: "-0.02em" },
        h3: { fontSize: "22px", fontWeight: 700, lineHeight: "28px", letterSpacing: "-0.015em" },
        h4: { fontSize: "18px", fontWeight: 600, lineHeight: "24px", letterSpacing: "-0.01em" },
        body1: { fontSize: "16px", fontWeight: 400, lineHeight: "24px", letterSpacing: "-0.005em" },
        body2: { fontSize: "14px", fontWeight: 400, lineHeight: "20px" },
        button: { fontSize: "14px", fontWeight: 600, letterSpacing: "0.01em", textTransform: "none" },
    },
    palette: {
        mode: "light",
        primary: {
            main: "#2E2B48",        // slate indigo (structural core)
            dark: "#373357",        // hover/active state
            light: "#474362",
            contrastText: "#FFFFFF",
        },
        secondary: {
            main: "#F97316",        // saffron — primary CTA
            dark: "#EA580C",        // hover
            light: "#FBBF24",       // amber
            contrastText: "#FFFFFF",
        },
        warning: { main: "#F59E0B" },
        error: { main: "#BA1A1A", contrastText: "#FFFFFF" },
        success: { main: "#047857" },
        background: {
          default: "#F8FAFC",
          paper:   "#FFFFFF",
        },
        // background: {
        //     default: "#FF0000",   // ← bright red for testing
        //     paper: "#FF0000",   // ← bright red for testing
        // },
        text: {
            primary: "#0F172A",
            secondary: "#475569",
            disabled: "#94A3B8",
        },
        divider: "#E2E8F0",
    },
    shape: { borderRadius: 8 }, // base rounded = 0.5rem
    breakpoints: {
        values: {
            xs: 0,
            sm: 450,
            md: 768,   // tablet start
            lg: 1280,  // desktop start
            xl: 1440,
        },
    },
    shadows: [
        "none",
        // Level 1 — cards & data panels
        "0 1px 3px 0 rgba(46,43,72,0.04), 0 1px 2px -1px rgba(46,43,72,0.04)",
        // Level 2 — hovered cards
        "0 4px 6px -1px rgba(46,43,72,0.07), 0 2px 4px -2px rgba(46,43,72,0.05)",
        // Level 3 — dropdowns & popovers
        "0 10px 15px -3px rgba(46,43,72,0.08), 0 4px 6px -4px rgba(46,43,72,0.04)",
        // Level 4 — modals
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        // …fallback for higher levels
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
        "0 20px 25px -5px rgba(46,43,72,0.12), 0 8px 10px -6px rgba(46,43,72,0.06)",
    ],
});

const theme = {
    ...defaultTheme,
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontWeight: 600,
                    borderRadius: 8,
                    padding: "8px 20px",
                    boxShadow: "none",
                    "&:hover": { boxShadow: "none" },
                },
                containedPrimary: {
                    backgroundColor: "#2E2B48",
                    color: "#FFFFFF",
                    "&:hover": { backgroundColor: "#373357" },
                },
                containedSecondary: {
                    backgroundColor: "#F97316",
                    color: "#FFFFFF",
                    "&:hover": { backgroundColor: "#EA580C" },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "#FDFEFE",
                    borderRadius: 8,
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#E2E8F0" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#CBD5E1" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#2E2B48",
                        borderWidth: "1.5px",
                    },
                    "&.Mui-focused": {
                        boxShadow: "0 0 0 3px rgba(249,115,22,0.15)",
                    },
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: "#0F172A",
                    "&::placeholder": { color: "#94A3B8", opacity: 1 },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                rounded: { borderRadius: 16 },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    border: "1px solid #E2E8F0",
                    boxShadow:
                        "0 1px 3px 0 rgba(46,43,72,0.04), 0 1px 2px -1px rgba(46,43,72,0.04)",
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: { borderRadius: 9999, height: 24, paddingLeft: 10, paddingRight: 10 },
                colorSecondary: {
                    backgroundColor: "rgba(249,115,22,0.1)",
                    color: "#EA580C",
                    border: "1px solid rgba(249,115,22,0.2)",
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: "#2E2B48",
                    fontSize: 12,
                    borderRadius: 8,
                },
            },
        },
    },
};

export default theme;